import { lud, rule } from "../core/rule";

// Email Inbox (sent-email history). ceo-level only: the backend refuses every
// other role on /api/auth/mails even for direct calls.
export const mailPermissions = { view: "mail.view" };

export const mailGrants = { "mail.view": rule(lud()) };
